import { styled } from '@mui/material/styles';

import { Box } from '../../../../components/atoms/Box';
import { SelectMenu } from '../../../../components/atoms/SelectMenu';
import { Typography } from '../../../../components/atoms/Typography';

import { COLORS } from '../../../../configs/colors';

export const TLCTypography = styled(Typography)`
  padding-bottom: 10px;
`;

export const TLCBox = styled(Box)`
  width: 100%;
  padding: 10px;
  border: 2px solid ${COLORS.CardBorder};
  border-radius: 5px;
  background-color: ${COLORS.CardBackground};
  box-sizing: border-box;
`;

export const StyledSelectMenu = styled(SelectMenu)`
  width: 100%;
`;
